import { useTranslation } from '@gem/modules/i18n';
import { copyTextToClipboard } from '@gem/utils';

export interface IDeviceSessionIPLineProps {
  ipAddress: string;
  onCopiedToClipboard?(message: string): void;
}

interface IDeviceSessionIPLinePresenterParams extends IDeviceSessionIPLineProps {}

interface IDeviceSessionIPLinePresenter {
  handleCopyToClipboard(): void;
}

export function useDeviceSessionIPLinePresenter(
  params: IDeviceSessionIPLinePresenterParams
): IDeviceSessionIPLinePresenter {
  const { onCopiedToClipboard, ipAddress } = params;
  const { t } = useTranslation();

  const presenter = {
    async handleCopyToClipboard(): Promise<void> {
      const result = await copyTextToClipboard(ipAddress);
      if (!result || !onCopiedToClipboard) {
        return;
      }
      onCopiedToClipboard(t('common_copied'));
    },
  };
  return presenter;
}
